import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

export const fetchDashboardData = createAsyncThunk('adminDashboard/fetchDashboardData', async () => {
  const response = await api.get('/admin/dashboard');
  return response.data.data;
});

const adminDashboardSlice = createSlice({
  name: 'adminDashboard',
  initialState: {
    totalUsers: 0,
    totalRepresentatives: 0,
    totalAreas: 0,
    totalComplaints: 0,
    recentComplaints: [],
    complaintsCountByStatus: [],
    complaintsCountByArea: [],
    complaintsCountByMonth: [],
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardData.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchDashboardData.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.totalUsers = action.payload.totalUsers;
        state.totalRepresentatives = action.payload.totalRepresentatives;
        state.totalAreas = action.payload.totalAreas;
        state.totalComplaints = action.payload.totalComplaints;
        state.recentComplaints = action.payload.recentComplaints;
        state.complaintsCountByStatus = action.payload.complaintsCountByStatus;
        state.complaintsCountByArea = action.payload.complaintsCountByArea;
        state.complaintsCountByMonth = action.payload.complaintsCountByMonth;
      })
      .addCase(fetchDashboardData.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message ?? null;
      });
  },
});

export default adminDashboardSlice.reducer;
